module.exports = __webpack_public_path__ + "static/media/vining_vining.dce6f982.gif";